import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesFinder: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29.715 3.805h1.52v24.39h-1.52Zm-1.53 24.39h1.53v1.52h-1.53Zm0-25.91h1.53v1.52h-1.53Z\"/><path fill=\"currentColor\" d=\"M2.285 29.715h1.52v1.52h24.38v-1.52h-9.14v-3.05h-1.52v-1.52h3.05v-1.53h-3.05V22.1H16v-4.57h-4.57v-3.05h1.53v-1.52h1.52V9.9H16V6.855h1.53v-4.57h10.66V.765H3.805v1.52h-1.52v1.52H.765V28.2h1.52Zm4.57-21.33h1.53v3.04h-1.53Zm0 12.19h1.53V22.1H9.9v1.52H16v1.53H9.9v-1.53H8.385V22.1h-1.53Z\"/><path fill=\"currentColor\" d=\"M23.615 8.385h1.53v3.04h-1.53Zm-1.52 12.19h1.52v1.52h-1.52Zm-1.52 1.52h1.52v1.52h-1.52Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesFinder
